export default {
  path: 'title-list',
  name: 'subscription/title-list',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "subscription-show-title-list" */ './TitleList')
}
